<div [formGroup]="formGroup">
    <div class="field-row">
        <div class="field-row-title">
            {{label()}}
        </div>
        <div class="field-row-element flex-column align-items-end">
            <mat-form-field subscriptSizing="dynamic">
                <mat-select formControlName="inputNumber">
                    @for (input of availableInputs(); track input.inputNumber) {
                        <mat-option [value]="input.inputNumber">{{input.name}}</mat-option>
                    }
                </mat-select>
                @if(formGroup.controls.inputNumber.hasError('required')) {
                    <mat-error>The Input is required</mat-error>
                }
            </mat-form-field>

            <mat-button-toggle-group formControlName="reversed">
                <mat-button-toggle [value]="false">Normal</mat-button-toggle>
                <mat-button-toggle [value]="true">Reversed</mat-button-toggle>
            </mat-button-toggle-group>
        </div>
    </div>

</div>
